/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_DescriptionInputs */

const en_viewer_description = /** @type {(inputs: Viewer_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View and explore JSON data with a beautiful tree view. Paste your JSON to visualize its structure instantly.`)
};

const ko_viewer_description = /** @type {(inputs: Viewer_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아름다운 트리 뷰로 JSON 데이터를 보고 탐색하세요. JSON을 붙여넣어 구조를 즉시 시각화합니다.`)
};

const ja_viewer_description = /** @type {(inputs: Viewer_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`美しいツリービューでJSONデータを表示・探索。JSONを貼り付けて構造を即座に視覚化します。`)
};

/**
* | output |
* | --- |
* | "View and explore JSON data with a beautiful tree view. Paste your JSON to visualize its structure instantly." |
*
* @param {Viewer_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_description = /** @type {((inputs?: Viewer_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_description(inputs)
	if (locale === "ko") return ko_viewer_description(inputs)
	return ja_viewer_description(inputs)
});